import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'row', 'duty', 'rowTemplate', 'rowsContainer', 'shiftDeleteLink' ]
  static values = { day: Number, hasOffDuty: { type: Boolean, default: false }, rotaOffDutyId: Number, shiftsCount: Number, arDutyIds: Array }

  rowTargetConnected(element) {
    this.shiftsCountValue = this.rowTargets.length
  }

  dutyTargetConnected(element) {
    this.processDutySelect(element)
  }

  rowTargetDisconnected(_element) {
    this.shiftsCountValue = this.rowTargets.length
  }

  processDutySelect(element) {
    if(!element.tomselect) {
      return
    }

    const selectedValue = parseInt(element.options[element.selectedIndex].value)

    // update underlying select element used by TomSelect
    element.querySelectorAll('option').forEach(opt => {
      const val = parseInt(opt.value)

      if(!val) {
        return
      }

      opt.disabled = false

      if(this.hasOffDutyValue && val != selectedValue && this.arDutyIdsValue.indexOf(val) == -1) {
        opt.disabled = true
      }
    })

    const ts = element.tomselect
    ts.clearOptions() // remove existing options
    ts.sync()
  }

  // hide delete shift link if there's only one shift per weekday left
  shiftsCountValueChanged(count) {
    if(count == 1) {
      this.shiftDeleteLinkTarget.classList.add('d-none')
    } else {
      this.shiftDeleteLinkTargets.forEach(link => {
        link.classList.remove('d-none')
      })
    }
  }

  addRotaShiftRow(event) {
    // prevent adding more than 3 duties per day
    if(this.rowTargets.length >= 3) {
      alert('Only 3 duties per weekday may be assigned.')
      return
    }

    let content = this.rowTemplateTarget.innerHTML
    content = content.replace(/CHILD_INDEX/g, new Date().valueOf())
    content = content.replace(/DAY/g, this.dayValue)
    this.rowsContainerTarget.insertAdjacentHTML('beforeend', content)
  }

  rotaShiftRemovedCallback(event) {
    //console.log('week-day | rotaShiftRemovedCallback', event.detail)

    this._removeRotaShiftRow(event.detail.row_index)
  }

  _removeRotaShiftRow(row_index) {
    const tr = this.rowTargets.find(t => t.dataset.rowIndex == row_index)

    this.rowsContainerTarget.removeChild(tr)

    if(this.rowTargets.length == 0) {
      this.hasOffDutyValue = false
    }
  }

  dutyChangedCallback(event) {
    //console.log(`weekday | day: ${this.dayValue} | dutyChangedCallback`, event.detail)
    const new_duty_id = parseInt(event.detail.new_duty_id)

    if(new_duty_id == this.rotaOffDutyIdValue) {
      this.hasOffDutyValue = true
    } else {
      this.hasOffDutyValue = false
    }
  }

  hasOffDutyValueChanged(value, prevValue) {
    //console.log('weekday | hasOffDutyValueChanged val', value, 'prev', prevValue)

    if(value == prevValue) { // for some reason callback is called
      return
    }

    this.dutyTargets.forEach(el => {
      this.processDutySelect(el)
    })
  }
}
